import { Icon } from './Icon';

type IconProps = {
  color?: string;
  size?: string;
};

export const InfoIcon: React.FC<IconProps> = ({ color, size = 'small', ...rest }) => {
  return (
    <Icon color={color} size={size} {...rest}>
      <path d="M12 4.96875C8.25391 4.96875 5.21875 8.03125 5.21875 11.75C5.21875 15.4961 8.25391 18.5312 12 18.5312C15.7188 18.5312 18.7812 15.4961 18.7812 11.75C18.7812 8.03125 15.7188 4.96875 12 4.96875ZM12 17.2188C8.96484 17.2188 6.53125 14.7852 6.53125 11.75C6.53125 8.74219 8.96484 6.28125 12 6.28125C15.0078 6.28125 17.4688 8.74219 17.4688 11.75C17.4688 14.7852 15.0078 17.2188 12 17.2188ZM12 7.97656C11.3438 7.97656 10.8516 8.49609 10.8516 9.125C10.8516 9.78125 11.3438 10.2734 12 10.2734C12.6289 10.2734 13.1484 9.78125 13.1484 9.125C13.1484 8.49609 12.6289 7.97656 12 7.97656ZM13.5312 14.9219V14.2656C13.5312 14.1016 13.3672 13.9375 13.2031 13.9375H12.875V11.2031C12.875 11.0391 12.7109 10.875 12.5469 10.875H10.7969C10.6055 10.875 10.4688 11.0391 10.4688 11.2031V11.8594C10.4688 12.0508 10.6055 12.1875 10.7969 12.1875H11.125V13.9375H10.7969C10.6055 13.9375 10.4688 14.1016 10.4688 14.2656V14.9219C10.4688 15.1133 10.6055 15.25 10.7969 15.25H13.2031C13.3672 15.25 13.5312 15.1133 13.5312 14.9219Z" />
    </Icon>
  );
};
